import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { masterInstance as axiosmaster } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getStudentAndCourseDetails = async (data) => {
  return decryptData(
    await axios.get(
      `/get-student-and-active-course-details?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const sendRefundLink = async (data) => {
  return decryptData(
    await axios.post(`/send-refund-link`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const sendAccountUpdateDetailsLink = async (data) => {
  return decryptData(
    await axios.post(`/send-account-update-details-link`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

// ************************************** Payment Refund List *************************************
export const getRefundList = async (data) => {
  return decryptData(
    await axios.get(
      `/get-refund-list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getRefundRejectedList = async (data) => {
  return decryptData(
    await axios.get(
      `/get-refund-rejected-list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};


export const updateRefundStatus = async (data) => {
  return decryptData(
    await axios.post(`/update-refund-status`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const updateRefundAmmount = async (data) => {
  return decryptData(
    await axios.post(`/update-refund-amount`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const initiateRefund = async (data) => {
  return decryptData(
    await axios.post(`initiate-refund`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
